<shell-modal-layout alignText="center" [title]="title">
  <vdst-separator></vdst-separator>
  <div class="modal__content">
    <iframe
      src="https://www.youtube.com/embed/NiD3o0cYfL8"
      class="video-facetec"
      title="Pichincha"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; 
      gyroscope; picture-in-picture; web-share"
      allowfullscreen
    >
    </iframe>
  </div>
  <div class="flex justify-center w-full container-button">
    <ui-button
      (clicked)="closeModal()"
      type="primary"
      size="md"
      width="full"
      label="Entendido"
      class="btn-loan"
    ></ui-button>
  </div>
</shell-modal-layout>
